<kodit-dropdown
  formCtrlId="izvor-fajl-select"
  [options]="ctrlOptions"
  [formCtrl]="formCtrl"
  (optionChanged)="itemChanged($event)"
>
</kodit-dropdown>
